import * as React from 'react';
import Spinner from 'react-bootstrap/Spinner';


export interface componentProps {
	loaded: bool;
	message: string;
}

export default function Loader(props: componentProps) {
		
	const {loaded, message} = props;

	if(!loaded){
		return (
			<React.Fragment>
				<div className="fade modal-backdrop show"></div>
				<div className="spinner">
					<div>
						<Spinner animation="border" variant="success" />
						<div className="spinner-text">{message}</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}